<template>
    <Wrapper>
        <Kanban />
    </Wrapper>
</template>
<script>
import { Wrapper, Kanban } from '../components';

export default {
    components: {
        Wrapper,
        Kanban
    }
};
</script>
